(() => {
  const initPdpVariantSync = () => {
    const containers = document.querySelectorAll(
      '.main-product_price_and_variations-block [id$="-variants-container"]'
    );

    containers.forEach((container) => {
      if (container.dataset.pdpVariantSyncInit === 'true') return;

      const pills = Array.from(
        container.querySelectorAll('variant-pill')
      );

      if (!pills.length) return;

      const getOptionName = (pill) => {
        const fieldset = pill.closest('fieldset');

        const legend = fieldset?.querySelector(
          'legend.variant-element_title'
        );

        return legend?.textContent
          .replace(':', '')
          .trim()
          .toLowerCase();
      };

      const getPillByName = (names) => {
        return pills.find((pill) =>
          names.includes(getOptionName(pill))
        );
      };

      /*
        Supported dependent option relationships:

        Pack Size → Color
        Crayon Type → Size
      */
const relationships = [
  {
    primaryNames: ['pack size'],
    secondaryNames: ['color', 'colour']
  },
  {
    primaryNames: ['pack size'],
    secondaryNames: ['style']
  },
  {
    primaryNames: ['crayon type'],
    secondaryNames: ['size']
  }
];

      const jsonSelector =
        pills[0]?.dataset.jsonSelector;

      const jsonElement =
        document.querySelector(jsonSelector);

      if (!jsonElement) return;

      let productData;

      try {
        productData = JSON.parse(
          jsonElement.textContent
        );
      } catch (error) {
        console.warn(
          'PDP variant sync: product JSON could not be read.'
        );
        return;
      }

      const variants = productData.variants || [];

      const setups = relationships
        .map((relationship) => {
          const primaryPill = getPillByName(
            relationship.primaryNames
          );

          const secondaryPill = getPillByName(
            relationship.secondaryNames
          );

          if (!primaryPill || !secondaryPill) {
            return null;
          }

          return {
            primaryPill,
            secondaryPill,
            primaryIndex: Number(
              primaryPill.dataset.optionIndex
            ),
            secondaryIndex: Number(
              secondaryPill.dataset.optionIndex
            ),
            secondaryFieldset:
              secondaryPill.closest('fieldset')
          };
        })
        .filter(Boolean);

      if (!setups.length) return;

      const getCheckedValue = (pill) => {
        return pill.querySelector(
          'input[type="radio"]:checked'
        )?.value;
      };

      const selectRadio = (pill, value) => {
        const radio = Array.from(
          pill.querySelectorAll(
            'input[type="radio"]'
          )
        ).find((input) => input.value === value);

        if (!radio || radio.checked) return;

        radio.checked = true;

        radio.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      };

      const filterSecondaryOptions = (
        secondaryPill,
        validValues
      ) => {
        const wrappers =
          secondaryPill.querySelectorAll(
            '.variant-options-wrap'
          );

        wrappers.forEach((wrapper) => {
          const radio = wrapper.querySelector(
            'input[type="radio"]'
          );

          if (!radio) return;

          wrapper.hidden =
            !validValues.includes(radio.value);
        });
      };

      const syncRelationship = (setup) => {
        const {
          primaryPill,
          secondaryPill,
          primaryIndex,
          secondaryIndex,
          secondaryFieldset
        } = setup;

        const selectedPrimary =
          getCheckedValue(primaryPill);

        if (!selectedPrimary) return;

        /*
          Find variants belonging to the selected
          primary option.
        */
        const matchingVariants =
          variants.filter((variant) => {
            return (
              variant.options?.[primaryIndex] ===
              selectedPrimary
            );
          });

        if (!matchingVariants.length) return;

        /*
          Get only the secondary option values that
          genuinely exist for this primary selection.
        */
        const validSecondaryValues = [
          ...new Set(
            matchingVariants
              .map(
                (variant) =>
                  variant.options?.[secondaryIndex]
              )
              .filter(Boolean)
          )
        ];

        if (!validSecondaryValues.length) return;

        /*
          Hide irrelevant secondary options.
        */
        filterSecondaryOptions(
          secondaryPill,
          validSecondaryValues
        );

        /*
          Always keep the secondary selector visible,
          even if only one value exists.
        */
        if (secondaryFieldset) {
          secondaryFieldset.hidden = false;
          secondaryFieldset.removeAttribute(
            'aria-hidden'
          );
        }

        const selectedSecondary =
          getCheckedValue(secondaryPill);

        /*
          If the current secondary selection does
          not belong to the new primary option,
          select a valid available one.
        */
        if (
          !validSecondaryValues.includes(
            selectedSecondary
          )
        ) {
          const firstAvailableVariant =
            matchingVariants.find(
              (variant) =>
                variant.available &&
                variant.options?.[secondaryIndex]
            ) || matchingVariants[0];

          const fallbackValue =
            firstAvailableVariant
              ?.options?.[secondaryIndex];

          if (fallbackValue) {
            selectRadio(
              secondaryPill,
              fallbackValue
            );
          }
        }
      };

      const syncAll = () => {
        setups.forEach(syncRelationship);
      };

      container.addEventListener(
        'change',
        () => {
          window.setTimeout(syncAll, 40);
        }
      );

      container.dataset.pdpVariantSyncInit =
        'true';

      window.setTimeout(syncAll, 80);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initPdpVariantSync
    );
  } else {
    initPdpVariantSync();
  }
})();